// Función que formatea un número para su correcta visualizacion segun idioma
export const numberFormat = (nb, lang) => {
    return (
      new Intl.NumberFormat (lang, {  
        minimumFractionDigits: 2
      }). format (nb)
    );
  }